import { render, staticRenderFns } from "./CFCComment.vue?vue&type=template&id=0dfbf024&"
import script from "./CFCComment.vue?vue&type=script&lang=js&"
export * from "./CFCComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports